import { type Condition } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';
import { convertQuery } from '@/utils/conditionQuery';

export const useRestoreAccounts = (condition?: Condition) => {
  const dal = useDAL();
  return dal.cloudAccounts.restore.useList(
    undefined,
    undefined,
    condition
      ? { filters: convertQuery(createCombineCondition([condition])) }
      : {}
  );
};
